import { NgModule } from '@angular/core';

import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';

import { HomeModule } from './components/cms/homepage/sys/home.module';
import { CmsPageModule } from './components/cms/page/sys/cms-page.module';
import { InventoryProductModule } from './components/inventory/product/sys/inventory-product.module';
import { InventoryCategoryModule } from './components/inventory/category/sys/inventory-category.module';
import { SettingsModule } from './components/settings/user/sys/settings.module';
import { SysConfig } from './services/core/system-configuration.service';
import { Ng2TableModule } from 'ng2-table/ng2-table';

// Need for defer included components by dynamic routing
const entryComponents = SysConfig.getAllComponents();

@NgModule({
  declarations: [ AppComponent ],
  imports: [
    SharedModule,
    HomeModule,
    CmsPageModule,
    InventoryProductModule,
    InventoryCategoryModule,
    SettingsModule,
    Ng2TableModule,
  ],

  entryComponents: [
    ...entryComponents
  ]
})
export class AppModule {
}

export { AppComponent } from './app.component';



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/app.module.ts